// extracted by mini-css-extract-plugin
module.exports = {"frame":"_474cd","container":"d527f","row":"_73df1","column":"_06b88"};